import React, { Component } from 'react';
import { connect } from 'react-redux';
import { path, mergeDeepLeft, clone } from 'ramda';
import Input from '../../common/Input';
import Breadcrumbs from '../../common/Breadcrumbs';
import '../../css/forms/default-forms.css';
import fields from './fields';
import approve from 'approvejs';
import * as rolePermissionStructure from '../../json/role-permission-structure';
import { linkDataToFields } from '../../utils/fields';
import { processFields } from '../../utils/prePost';
import { fetchRoleById, updateRoleById } from '../../api/roles';
import '../../css/forms/default-forms.css';
import { push } from "react-router-redux";
import mapPermissionValues from "./mapPermissionValues";
import PermissionsTable from "../../сomponents/PermissionsTable";
import hasAccess from "../../helpers/permissionChecker";

export class RoleEdit extends Component {

  constructor(props) {
    super(props);
    this.state = {
      submit: false,
      errors: [],
      fields: fields,
      permissions: clone(rolePermissionStructure),
      fieldsSync: false,
    };
    this.submit = this.submit.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.changeFormValue = this.changeFormValue.bind(this);
    this.cancel = this.cancel.bind(this);
    this.fetchDataRouteById = this.fetchDataRouteById.bind(this);
  }

  componentDidMount() {
    this.fetchDataRouteById();
  }

  componentDidUpdate() {
    if (this.state.fieldsSync === false) {
      const role = path(['roles', 'role'], this.props);
      if (role) {
        const fields = linkDataToFields(role, this.state.fields);
        this.setState({
          fields: fields,
          permissions: mapPermissionValues(this.state.permissions, role.permissions),
          fieldsSync: true,
        });
      }
    }
  }

  fetchDataRouteById() {
    const id = path(['match', 'params', 'id'], this.props);
    this.props.getDataById(id);
  }

  submitForm(e, fields) {
    e.preventDefault();
    let check = true;
    for (let field in fields) {
      fields[field].errors = [];
      let result = approve.value(fields[field].value, fields[field].rules);
      if (result.errors.length > 0) {
        check = false;
        fields[field].errors = Array.from(result.errors);
      }
    }
    return {
      fields,
      check,
    };
  }

  submit(e) {
    e.preventDefault();
    let result = this.submitForm(e, this.state.fields);
    const id = path(['match', 'params', 'id'], this.props);

    if (result.check === false) {
      this.setState({
        fields: result.fields,
      });
    } else {
      this.props.saveForm(
        id,
        {
          ... processFields(this.state.fields),
          permissions: this.state.permissions.fields
        }
      );
    }
    return false;
  }

  changeFormValue(field, newObject) {
    let stateClone = clone(this.state);
    stateClone.fields[field] = newObject;
    this.setState(mergeDeepLeft(stateClone, this.state));
  }

  cancel() {
    this.props.goToRoles();
  }

  changePermissionValue = (newObject) => {
    let stateClone = clone(this.state);
    stateClone.permissions.fields = newObject;
    this.setState(mergeDeepLeft(stateClone, this.state));
  }

  render() {
    const hasAccessForEdit = hasAccess({
      'permAreaKey': 'roles',
      'permTypeKey': 'edit',
    });
    const disableFieldForEdit = !hasAccessForEdit;
    return (
      <div className="row">
        <div className="col">
          <Breadcrumbs list={[
            { url: '/pages/dashboards', icon: 'dashboard', name: 'Dashboard' },
            { url: '/pages/roles', icon: 'people', name: 'Roles' },
            { icon: 'person', name: 'Edit Role' },
          ]}/>
          <div className="card rounded">
            <div className="card-header rounded-top">
              Edit Role
            </div>
            <div className="card-block">
              <div className="col-12" style={{ paddingBottom: '40px' }}>
                <button
                  className={'btn btn-danger btn-outline float-right'}
                  style={{ marginLeft: '10px' }}
                  onClick={this.cancel}
                >
                  <i className="fa fa-remove"></i>
                  <span style={{ paddingLeft: '3px' }}>Cancel</span>
                </button>
                {hasAccessForEdit &&
                <button className={'btn btn-success btn-outline float-right'} onClick={this.submit}>
                  <i className="fa fa-check"></i>
                  <span style={{ paddingLeft: '3px' }}>Save & Continue</span>
                </button>
                }
              </div>
              <form onSubmit={this.submit}>
                <div className="col-12">
                  <Input
                    disabled={disableFieldForEdit}
                    field={this.state.fields['roleName']}
                    onChange={this.changeFormValue}
                  />
                  <PermissionsTable disabled={disableFieldForEdit} permissions={this.state.permissions} onChange={this.changePermissionValue}/>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => state;

const mapDispatchToProps = (dispatch) => {
  return {
    goToRoles: () => {
      dispatch(push('/pages/roles'));
    },
    getDataById: (id) => {
      fetchRoleById(id)(dispatch);
    },
    saveForm: (id, data) => {
      updateRoleById(id, data)(dispatch);
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RoleEdit);



// WEBPACK FOOTER //
// ./src/containers/RoleEdit/index.js